import React, { Component } from "react";
import { connect } from "react-redux";

import EventComponent from "./EventComponent";

export class EventContainer extends Component {
  render() {
    const { community, event, language, index } = this.props;

    return (
      <EventComponent
        event={event}
        community={community}
        language={language}
        index={index}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Event/EventContainer.js